import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://cyjkasgjxkpcvvczunjr.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN5amthc2dqeGtwY3Z2Y3p1bmpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyODMzNDksImV4cCI6MjA3NTg1OTM0OX0.ovXy-bORMn4u6DCjrLednMsEwN_cjvRVDiGOWCXmhXU'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
